import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_PETITION_PAGE_NEWLY_CREATED_PETITIONS = createFcmDetails(
	'petition_page_newly_created_petitions',
	{
		owner: 'SEO/Growth',
		context: 'Petition details page',
		description: 'When enabled, shows a row of petition cards for newly created petitions',
		import: false,
	},
);
